import {getHostVariables} from '../utils';
import {HELPERS_IMMEDIATE, HOIST_COMPOSED_PATH} from '../symbols';

export function onActionHoisted(targetEl, targetSelector, host, actionType, action = {}) {
	const {type, payload, meta, error} = action;
	const hostVariables = getHostVariables(host);

	// stop this event from propagating, since we'll turn around and redispatch
	// from the original host
	if (meta.event) meta.event.stopPropagation();

	hostVariables[HELPERS_IMMEDIATE].dispatch(
		type,
		payload,
		{
			...meta,
			retargeted: true,
			[HOIST_COMPOSED_PATH]: meta.event.composedPath()
		},
		error
	);
}
